import toast from 'react-hot-toast'
import {AuthModel} from './_models'
import Cookies from 'universal-cookie'
import {AxiosInstance, AxiosRequestConfig, AxiosError} from 'axios'
import {createBrowserHistory} from 'history'
import JSONbig from 'json-bigint'

type APIError = {
  status: number
  message: string
}

let logoutHandler: ((tokenGone: boolean) => void) | null = null

export const setLogoutHandler = (fn: (tokenGone: boolean) => void) => {
  logoutHandler = fn
}

export const customHistory = createBrowserHistory()
export const temptoken =
  'eyJhbGciOiJIUzM4NCJ9.eyJpc3MiOiJJQVRfVGVhbSIsImlhdCI6MTc1ODk1NDcyMiwiZXhwIjoxNzU5MDQxMTIyLCJ1c2VybmFtZSI6ImNsaWVudCIsInJvbGUiOlt7ImF1dGhvcml0eSI6IkNsaWVudCJ9XX0.dIm3SwIvSyybWEFDxcd91D3q0mvgwhJC8k-W0jVcajUPyYLAW6ReThjeOGdOruOA'

const cookies = new Cookies()

const AUTH_LOCAL_STORAGE_KEY = 'kt-auth-react-v'

const JWT_AUTH_KEY = 'sms_panel'

const getAuth = (): AuthModel | undefined => {
  if (!localStorage) {
    return
  }

  const lsValue: string | null = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY)
  if (!lsValue) {
    return
  }

  try {
    const auth: AuthModel = JSON.parse(lsValue) as AuthModel
    if (auth) {
      // You can easily check auth_token expiration also
      return auth
    }
  } catch (error) {
    console.error('AUTH LOCAL STORAGE PARSE ERROR', error)
  }
}

export const getJwt = (): AuthModel | undefined => {
  const jwt = cookies.get(JWT_AUTH_KEY)
  if (!jwt) {
    // if (process.env.NODE_ENV === 'development') {
    //   return {
    //     accessToken: temptoken,
    //   }
    // } else {
    //   return
    // }
    return
  }
  // console.log(jwt)
  return {
    // accessToken: temptoken,
    accessToken: jwt,
  }
}

export const getParentJwt = (parentCount: number): AuthModel | undefined => {
  const jwt = cookies.get(`${JWT_AUTH_KEY}_parent_${parentCount}`)
  if (!jwt) {
    return
  }
  // console.log(jwt)
  return {
    accessToken: jwt,
  }
}

const now: any = new Date()

// TODO: need to get and set JWT from the server
export const setJwt = (auth: AuthModel | undefined) => {
  // console.log(auth.accessToken)
  if (auth && auth.accessToken) {
    cookies.set(JWT_AUTH_KEY, auth.accessToken, {
      path: '/',
      expires: new Date(now * 5),
      // secure: true,
      // httpOnly: true
    })
  } else {
    cookies.remove(JWT_AUTH_KEY, {path: '/'})
  }

  const jwt = cookies.get(JWT_AUTH_KEY)
  // if(!jwt) {
  //   return
  // }
  // console.log(jwt)
}

export const setParentJwt = (auth: AuthModel | undefined, parentCount: number) => {
  // console.log(auth.accessToken)
  // cookies.set('jwt_auth_parent', auth?.accessToken, {
  //   path: '/',
  //   expires: new Date(now * 5000),
  //   // secure: true,
  //   // httpOnly: true
  // })

  const now = Date.now()
  const expiresInMilliseconds = 50000000
  const expires = new Date(now + expiresInMilliseconds)
  // console.log(parentCount)

  if (auth && auth.accessToken) {
    // console.log('setParent', auth)
    cookies.set(`${JWT_AUTH_KEY}_parent_${parentCount}`, auth.accessToken, {
      path: '/',
      expires: expires,
      // secure: true,
      // httpOnly: true
    })
  } else {
    // console.log('removeparentjwt')
    cookies.remove(`${JWT_AUTH_KEY}_parent_${parentCount}`, {path: '/'})
  }

  const jwt = cookies.get(JWT_AUTH_KEY)
  // if(!jwt) {
  //   return
  // }
  // console.log(jwt)
}

export const removeParentJwt = (parentCount: number) => {
  cookies.remove(`${JWT_AUTH_KEY}_parent_${parentCount}`, {path: '/'})
}

export const getStorageParentCount = () => {
  const number = localStorage.getItem('parentCount')
  return number ? parseInt(number, 10) : 0
}

export const setStorageParentCount = (count: number) => {
  localStorage.setItem('parentCount', count.toString())
}

const setAuth = (auth: AuthModel) => {
  if (!localStorage) {
    return
  }

  try {
    const lsValue = JSON.stringify(auth)
    localStorage.setItem(AUTH_LOCAL_STORAGE_KEY, lsValue)
  } catch (error) {
    console.error('AUTH LOCAL STORAGE SAVE ERROR', error)
  }
}

const removeAuth = () => {
  if (!localStorage) {
    return
  }

  try {
    localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY)
  } catch (error) {
    console.error('AUTH LOCAL STORAGE REMOVE ERROR', error)
  }
}

export function setupAxios(axios: AxiosInstance) {
  axios.defaults.headers.common['Accept'] = 'application/json'

  axios.defaults.transformResponse = [
    (data) => {
      try {
        // All big number which are out of range JS Engine it will convert it to string
        return JSONbig({storeAsString: true}).parse(data)
      } catch (err) {
        return data
      }
    },
  ]

  // Request Interceptor: Attach Authorization Header
  axios.interceptors.request.use(
    (config: AxiosRequestConfig) => {
      const auth = getJwt() // Retrieve stored token
      // console.log(auth)
      if (auth?.accessToken && config.headers) {
        config.headers.Authorization = `Bearer ${auth.accessToken}`
      }
      return config
    },
    (error: AxiosError) => Promise.reject(error)
  )

  // Response Interceptor: Handle 401 (Unauthorized) and Logout
  axios.interceptors.response.use(
    (response) => response,
    (error: AxiosError) => {
      const status = error.response?.status
      const message = error.response?.data?.message
      const backendError = error.response?.data?.error
      if (status === 401) {
        if (message?.includes('JWT expired') || backendError === 'Unauthorized') {
          toast.error('Token expired or unauthorized access. Logging out...')

          logoutHandler && logoutHandler(true)
        }
      } else if (status === 400) {
        if (message?.includes('JWT expired')) {
          toast.error('Token expired or unauthorized access. Logging out...')

          logoutHandler && logoutHandler(true)
        }
      }
      return Promise.reject(error)
    }
  )
}

export {getAuth, setAuth, removeAuth, AUTH_LOCAL_STORAGE_KEY}
